import type TimeSuggestionsViewState from './schema/TimeSuggestionsViewState';
import { createStore } from 'satcheljs';
import TimingType from '../store/schema/TimeSuggestionsTimingTypes';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

const defaultTimeSuggestionsStore: TimeSuggestionsViewState = {
    timeSuggestions: null,
    previousStart: null,
    previousMeetingDurationInMinutes: 0,
    timeSuggestionsRequestState: null,
    lastFindMeetingTimesRequestId: null,
    lastFindMeetingTimesRequestDate: null,
    showSearchCriteriaDialog: false,
    durationSearchCriteria: 0,
    timingSearchCriteria: TimingType.NextAvailable,
    shouldAdjustStartTimeEndTime: false,
    calendarComponent: CalendarComponent.Unknown,
    ariaRequestCompletionResourceId: '',
};

export const getStore = createStore<TimeSuggestionsViewState>(
    'timeSuggestionsStore',
    defaultTimeSuggestionsStore
);

export default getStore;
